import * as React from "react";
export const PortfolioContext = React.createContext(undefined);
export function usePortfolio() {
    const context = React.useContext(PortfolioContext);
    if (typeof context === "undefined") {
        throw new Error("usePortfolioCore must be used within a PortfolioCoreProvider");
    }
    return context;
}
